var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSidebarExpand = function SvgSidebarExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "#E5EBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.058 16-3.53 3.529a.666.666 0 1 0 .944.942l4-4a.666.666 0 0 0 0-.943l-4-4a.666.666 0 1 0-.943.943L17.058 16Z",
    fill: "#2C3439"
  })));
};
export default SvgSidebarExpand;